import React, {useState, useEffect} from 'react'
import { getImageUrlFormat_16_9_600, getImageUrlFormat_9_16_600 } from '../helper/images';
import CustomImage from './ui/Image';
import { getContentAd } from './Ad';
import { Article as Ar, GalleryArticle, PreviousVote, VoteEntry } from '../helper/interfaces'
import { AppTheme, GalleryVotingType, ImageOrientationType } from '../helper/enums';
import { voteClientSide } from '../helper/api';
import useVoting from '../lib/useVoting';
import { getLinkObjectFromTeaser } from '../helper/link';
import { Link2 } from 'react-feather';

interface Data {
  article: Ar | GalleryArticle
  contentBlocked?: boolean
}

function getRatingContent (items: number, imageId: string, votedImages: any, voteImages: any, vote: number) {
  let content: React.ReactNode[] = [];
  for (let i = 1; i <= items; i++) {
    const isSelected = (votedImages != undefined && votedImages[imageId] === i) || vote == i
    content.push(<button type="button" key={`rating-${imageId}-${i} ${vote > 0 ? 'voted':''}`} className={`score__element rating-${isSelected ? "selected":"notselected"}`} onClick={() => {
      if(vote == 0) {voteImages(imageId, i)}
      }}>{i} {isSelected ? "":""}</button>);
  }
  return content;
}

function Images(props: Data) {
  let adItemCounter = 1
  const imageCount = props.article.images.length

  const [voteSelected, setVoteSelected] = useState(false)
  const [imageVotes, setImageVotes] = useState({})
  const [imageVoted, setImageVoted] = useState<String | undefined>(undefined)
  const [voted, setVoted] = useState<boolean | undefined>(undefined)
  const [previousVote, setPreviousVote] = useState<PreviousVote | undefined>(undefined)
  const [voteResult, setVoteResult] = useState<VoteEntry[] | null>(null)
  const voting = props.contentBlocked ? undefined : (props.article as GalleryArticle).voting

  const [votesLocalStorage, setVotesLocalStorage] = useVoting()

  const voteImages = (imageId: string, vote: number) => {
    let newVotes = {...imageVotes}
    newVotes[imageId] = vote
    setImageVotes(newVotes)
    setVoteSelected(true)
  }

  const sendSingleImageVote = async (imageId: string) => {
    let data: { id: string }[] = []
    data.push({id: imageId})
    
    let result: any = await voteClientSide(props.article.id, data);
    setVoteResult(result)
    if(result) {
      setVotesLocalStorage([...votesLocalStorage, { articleId: props.article.id, votes: data }])
      setPreviousVote({ articleId: props.article.id, votes: data } as PreviousVote)
    }
  };

  const sendVote = async () => {
    let data: { id: string, rate?: number }[] = []
    if (voting && voting.type == GalleryVotingType.Voting) {
      data.push({id: imageVoted as string})
    }
    if (voting && voting.type == GalleryVotingType.Rating) {
      Object.keys(imageVotes).forEach(key => {
        data.push({id: key, rate: imageVotes[key]})
      })
    }
    let result: any = await voteClientSide(props.article.id, data);
    setVoteResult(result)
    if(result) {
      setVotesLocalStorage([...votesLocalStorage, { articleId: props.article.id, votes: data }])
      setPreviousVote({ articleId: props.article.id, votes: data } as PreviousVote)
    }
  };

  useEffect(() => {
    const oldVote = votesLocalStorage?.find((m) => m.articleId == props.article.id)
    setVoted(oldVote != null)
    if(oldVote) {
      setPreviousVote(oldVote)
    }
  }, [votesLocalStorage])

  const adAfterImages = process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nb ? 3 : 6

  const articleImages = props.contentBlocked ? props.article.images.slice(0, 1) : props.article.images

  return (
    <div className="article-images">
      {articleImages.map((image, i, arr) => {
        const articleImage = image.image ?? image;
        const imageUrl = (articleImage.alignment !=  ImageOrientationType.Portrait) ? getImageUrlFormat_16_9_600(image) : 
          getImageUrlFormat_9_16_600(image);

        const imageClass = (articleImage.alignment != ImageOrientationType.Portrait) ? "aspect-w-16 aspect-h-9" : "aspect-w-9 aspect-h-16"
        const credit = articleImage?.credit || ''

        const previousVoteEntry = previousVote?.votes?.find((m) => m?.id == image.id)
        const votedResultEntry = voteResult?.find((m) => m?.id == image.id)
        const rate = votedResultEntry?.rate || articleImage?.rate || null
        const votes = votedResultEntry?.votes || articleImage?.votes || null

        const isNN = process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nn;


        const linkObject = getLinkObjectFromTeaser(image)

        return imageUrl && (
          <React.Fragment  key={`fragment-image-${image.id}`}>
            <div className="article-images__image" key={`image-${image.id}`}>
            {linkObject.externalLink &&
              <a href={linkObject.externalLink} target="_blank" rel="noopener noreferrer">
                  <div className="article-images__image__container">
                    <div className={imageClass}>
                      <div className="image-placeholder icon-slideshow"></div>
                      <CustomImage
                        key={`image-${image.id}-url${imageUrl}`}
                        src={imageUrl}
                        alt={image.subline}
                        fill
                        className="object-cover"
                      />
                    </div>
                    {isNN && <>
                      <div className="teaser-image-icon">
                        <Link2 />
                      </div>
                      {imageCount > 1 &&
                        <div className="article-images__image__count">
                          {i + 1} von {imageCount}
                        </div>
                      }
                      </>
                    }
                    {!isNN  && !(imageCount > 1) && <>
                      <div className="teaser-image-icon">
                        <Link2 />
                      </div>
                      </>
                    }
                    {!isNN && (imageCount > 1)&& <>
                      <div className="article-images__image__count flex-display">                        
                        <Link2 />
                        <div>
                        {i + 1} von {imageCount}
                        </div>
                      </div>
                      </>
                    }
                  </div>
                </a>
              }
              {!linkObject.externalLink &&
                <div className="article-images__image__container">
                  <div className={imageClass}>
                    <div className="image-placeholder icon-slideshow"></div>
                    <CustomImage
                      key={`image-${image.id}-url${imageUrl}`}
                      src={imageUrl}
                      alt={image.subline}
                      fill
                      className="object-cover"
                    />
                  </div>
                  {imageCount > 1 &&
                    <div className="article-images__image__count">
                      {i + 1} von {imageCount}
                    </div>
                  }
                </div>
              }
              {(image.title || image.subline || credit) &&
                <div className={`article-images__image__meta ${voting?.type ? "article-images__image__meta_voting" : ""}`}>
                  {image.title &&
                    <h3 className="article-images__image__meta__title">{image.title}</h3>
                  }
                  <span className="article-images__image__meta__subline">{i + 1}/{arr.length} - {image.subline || ''} </span>
                  {credit &&
                    <span className="article-images__image__meta__credit">&copy; {credit}</span>
                  }
                </div>
              }
              { voting && voting.type == GalleryVotingType.Rating &&
                  <div className="slideshow__modul__score" key={`rating-${image.id}`}>
                    <h6>{voting.lead}</h6>
                    { voted == false &&
                      <div className="slideshow__modul__score__container" aria-label="Bewerten">
                        {getRatingContent(voting.scaleTo, image.id, imageVotes, voteImages, 0)}
                      </div>
                    }
                    {
                      voted == true && 
                      <div className="slideshow__modul__score__container voted" aria-label="Abgestimmt">
                        {getRatingContent(voting.scaleTo, image.id, imageVotes, voteImages, previousVoteEntry?.rate || -1)}
                      </div>
                    }
                    { voting?.hideResult != true && voted == true && rate > 0 &&
                      <div>
                        <h6 className="mt-3">
                          Durchschnitt {rate}
                        </h6>
                      </div>
                    }
                     { voting?.hideResult != true && voted == true && rate == null &&
                     <div>
                        Noch keine Bewertung vorhanden
                    </div>
                    }
                  </div>
              }
              { voting && voting.type == GalleryVotingType.Voting &&
                  <div key={`voting-${image.id}`} className="slideshow__modul_voting">
                    <h6>{voting.lead}</h6>
                    { voted == false &&
                      <div className={`btn btn-voting voting-${image.id == imageVoted ? "selected":"notselected"}`} onClick={() => {
                        setImageVoted(image.id);
                        setVoteSelected(true);
                        sendSingleImageVote(image.id);
                        }}>
                        Für dieses Bild abstimmen
                      </div>
                    }
                    { (previousVoteEntry || previousVote) &&
                      <div className={`btn btn-voting voting-${previousVoteEntry ? "selected voted" : "notselected voted"}`}>
                        {previousVoteEntry ? "Abgestimmt!" : "Für ein anderes Bild abgestimmt."}
                      </div>
                    }
                    { voting?.hideResult != true && voted == true && votes > 0 &&
                      <h6>
                        {votes} {votes == 1 ? "Stimme" : "Stimmen"}
                      </h6>
                    }
                     { voting?.hideResult != true && voted == true && votes == null &&
                     <h6>
                        Noch keine Stimme abgegeben
                    </h6>
                    }
                  </div>
              }
            </div>
            { ((i+1)%adAfterImages == 0) && getContentAd(++adItemCounter) }
          </React.Fragment>

        )

      })}
      { voted == false && voteSelected && voting && voting.type == GalleryVotingType.Rating &&
        <div className="text-center">
          <div id="votingButton" className="btn btn-voting btn-space-lg" onClick={() => {sendVote()}}>
            Jetzt abstimmen!
          </div>
        </div>
      }
      { voted == true && voting && voting.type == GalleryVotingType.Rating &&
        <div className="text-center">
          <div id="votingButton" className="btn btn-voting voted btn-space-lg">
            Abgestimmt!
          </div>
        </div>
      }
    </div>
  );
}

export default Images